<div
  class="top d-flex justify-content-between align-content-center flex-column"
>
  <nav class="navbar login-navbar ms-lg-3">
    <img class="login-logo" src="assets/images/CDBlack.png" alt="NCS^ INDORE" />
  </nav>

  <div class="container">
    <div
      class="w-100 row d-flex justify-content-center align-items-center login-component"
    >
      <!-- Left card (logo) -->
      <div class="col-lg-6 left-card">
        <div
          class="card left-card-img shadow-none bg-transparent rounded-0 mb-0"
          *ngIf="
            applicationLogo !== 0 && applicationLogo !== undefined;
            else fallbackLogo1
          "
        >
          <img
            src="{{ getDoc(applicationLogo) }}"
            class="applicatin-img"
            alt="application logo"
          />
        </div>

        <ng-template #fallbackLogo1>
          <div
            class="card shadow-none bg-transparent rounded-0 mb-0 left-card-img"
          >
            <img
              src="assets/images/CDBlack.png"
              width="500"
              alt="Fallback Logo"
            />
          </div>
        </ng-template>
      </div>

      <!-- Right card (form) -->
      <div class="col-lg-6 col-md-8 col-sm-10 col-12 righ-card-top">
        <div class="card-body right-card shadow mycardpadding">
          <div>
            <!-- Mobile-only app logo -->
            <div
              class="text-center w-100 align-content-center application-logo"
              *ngIf="applicationLogo !== 0 && applicationLogo !== undefined"
            >
              <img src="{{ getDoc(applicationLogo) }}" alt="AppLogo" />
            </div>

            <!-- App name -->
            <div class="text-center">
              <h1 class="login-application-name">{{ appName }}</h1>
            </div>

            <!-- Page heading -->
            <div class="text-center mb-1">
              <h5 class="pb-1 pt-2">Forgot Password?</h5>
              <form-error [form]="form"></form-error>
            </div>

            <!-- Subtitle description -->
            <div class="text-center mb-3">
              <p class="text-muted forgot-subtitle">
                Enter your registered email ID
                <i
                  class="bi bi-envelope-at-fill"
                  style="color: skyblue; font-size: larger"
                ></i>
                to receive your password
                <i
                  class="bi bi-key-fill"
                  style="color: gold; font-size: larger"
                ></i>
              </p>
            </div>

            <!-- Form -->
            <div class="form-body dropdown-pd-none">
              <form class="row" #uiForm="ngForm">
                <div class="col-12 mt-3">
                  <mat-form-field
                    appearance="outline"
                    class="w-100 no-wrap-asterisk"
                  >
                    <mat-label>Email Address</mat-label>
                    <input
                      matInput
                      [(ngModel)]="form.data['loginId']"
                      type="email"
                      id="loginId"
                      name="loginId"
                      placeholder="Enter your registered email"
                      required
                    />
                    <mat-icon matPrefix class="text-secondary opacity-50"
                      >email</mat-icon
                    >
                  </mat-form-field>
                </div>

                <div class="col-12 mt-3">
                  <button
                    mat-raised-button
                    color="primary"
                    type="submit"
                    (click)="forgotPassword()"
                    class="w-100 fat-button shadow-sm"
                    [disabled]="!uiForm.valid"
                  >
                    <mat-icon class="me-1">send</mat-icon>
                    <span class="fs-6 tracking-wider">Send </span>
                  </button>
                </div>

                <div class="col-12 text-center mt-4">
                  <a
                    routerLink="/login"
                    class="back-to-login text-decoration-none fw-bold"
                  >
                    <mat-icon class="back-icon">arrow_back</mat-icon>
                    Back to Sign In
                  </a>
                </div>
              </form>
            </div>

            <!-- Org branding -->
            <div class="row mt-4">
              <div class="col-lg-12">
                <div class="w-100">
                  <div class="text-center">
                    <span class="login-managed-by">Managed by</span>
                    <span class="org-name">{{ orgName }}</span>
                  </div>
                  <div
                    class="row text-center"
                    *ngIf="
                      orgLogo !== 0 && orgLogo !== undefined;
                      else fallbackLogo
                    "
                  >
                    <a target="_blank" title="Org logo">
                      <img
                        class="org-logo"
                        src="{{ getDoc(orgLogo) }}"
                        alt=""
                      />
                    </a>
                  </div>
                  <ng-template #fallbackLogo>
                    <div class="row text-center">
                      <a target="_blank" title="NCS Indore">
                        <img
                          class="org-logo"
                          src="assets/images/CDBlack.png"
                          width="100px"
                        />
                      </a>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <footer class="footer py-3 mt-auto">
    <div class="container-fluid">
      <p class="text-center mb-0">
        <span class="text-muted">Powered by</span> NCS^ NO-CODE Platform Pvt.
        Ltd.
      </p>
    </div>
  </footer>
</div>
